import theme, { titleCommon } from '../../styles/theme';

export default {
  container: {
    display: ({ hidden }) => (hidden ? 'none' : 'initial'),
    [theme.breakpoints.up('md')]: {
      display: ({ hidden }) => (hidden ? 'none' : 'flex'),
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  calloutContainer: {
    padding: '16px 24px',
    marginBottom: '16px',
    backgroundColor: ({ colourTheme }) => colourTheme.backgroundColour,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 'calc(50% - 8px)',
      padding: '16px 32px',
      marginBottom: 0,
    },
  },
  calloutLink: {
    ...titleCommon,
    fontSize: '16px',
    lineHeight: '22px',
    textDecoration: 'none',
    textTransform: 'uppercase',
    '&, &:visited, &:focus': {
      color: ({ colourTheme }) => colourTheme.textColour,
    },
    '&:hover': {
      color: ({ colourTheme }) => colourTheme.linkHover,
    },
  },
};
